export default __webpack_public_path__ + "static/media/Chestguard of the Black Warden.1381a8b0.jpg";